import { Calendar } from 'primereact/calendar';
import './DateRangePicker.module.scss';

interface DatePickerProps {
  value: Date | null;
  onChange: (value: Date | null) => void;
  showTime?: boolean;
  timeOnly?: boolean;
  hourFormat?: '12' | '24';
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
}

const DatePicker = ({
  value,
  onChange,
  showTime = false,
  timeOnly = false,
  hourFormat = '24',
  minDate,
  maxDate,
  disabled = false,
}: DatePickerProps) => (
  <Calendar
    value={value}
    onChange={(e) => onChange(e.value as Date | null)}
    selectionMode="single"
    showTime={showTime}
    timeOnly={timeOnly}
    hourFormat={hourFormat}
    dateFormat="dd/mm/yy"
    className="w-full"
    panelStyle={{ marginLeft: '14rem' }}
    minDate={minDate}
    maxDate={maxDate}
    disabled={disabled}
  />
);

export default DatePicker;
